var _path, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgExpediaGrayIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_231_29",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 3,
    y: 3,
    width: 31,
    height: 31
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.0024 3.00061H33.003V33.0012H3.0024V3.00061Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_231_29)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.9494 12.8268L20.547 14.5296L15.6276 15.9408L3.18059 20.2644C2.80799 17.8198 3.0486 15.3209 3.88079 12.9924C6.65279 5.18395 15.2334 1.10155 23.0274 3.88795C24.9052 4.55335 26.6307 5.58802 28.1023 6.93094C29.5738 8.27387 30.7615 9.89787 31.5954 11.7072C31.0734 11.7072 30.375 11.745 29.7648 11.898L24.5646 13.3848L15.7284 5.74375L14.814 5.97415L19.9494 12.8268ZM30.3624 13.9572C31.023 13.7412 31.698 13.347 32.1552 13.0554C33.2911 16.2863 33.2822 19.8094 32.13 23.0346C29.3454 30.8412 20.7756 34.9217 12.9708 32.1389C10.5404 31.274 8.37428 29.7967 6.68166 27.85C4.98905 25.9032 3.8272 23.5527 3.30839 21.0258L16.2252 18.0126L21.1068 16.614L21.5136 18.3816L20.7756 26.8992L21.6792 26.6076L25.1496 15.4458L30.3624 13.9572Z",
    fill: "#FBFDFD"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgExpediaGrayIcon);
export default __webpack_public_path__ + "static/media/expedia-gray-icon.14384981f3813264e85c16903755dadc.svg";
export { ForwardRef as ReactComponent };